module.exports = __webpack_public_path__ + "1b10a3d6d4188f05c488f74559a7cd26.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/charts/c_pie_hide_labels.png
// module id = 890
// module chunks = 7